import { IFilterPasstModel } from "../interfaces/passt/IFilterPasstModel";

export class FilterPasstModel implements IFilterPasstModel{
    anio: number;
    idSede: number;
    page: number;
    pageSize: number;
    idCompania: number;
    
    constructor(){
        this.anio= new Date().getFullYear();
        this.idSede = 0;
        this.page = 1;
        this.pageSize = 30;
        this.idCompania = 0;
    }
}